// The positions a list's chips filter by: Players, My Team's free agents and
// News (B-416). One copy, where there were two of it.
//
// A real league's Players page and free agents take the league's own from the
// page they read (`PlayersPage.filters`, B-511: each position its lineup
// starts and each slot that takes several, one at a time), so a league of
// defensive players filters by DL, LB and DB and one with no kicker offers
// none; News takes them from the league's scoring table (the audit of
// 2026-10-20). This list is what a list falls back to while it reads.
import type { PositionFilterView } from '@fsp/domain';
import { positionLabel } from '../../kit';

export const POOL_POSITIONS: readonly string[] = ['QB', 'RB', 'WR', 'TE', 'K', 'DST'];

/** The fallback's choices, a position each, before a page has said the league's. */
export function fallbackChoices(): PositionFilterView[] {
  return POOL_POSITIONS.map((p) => ({
    id: p,
    label: positionLabel(p),
    name: positionLabel(p),
    positions: [p],
  }));
}

/** Two lists of positions with the same members: which choice a list's positions are. */
export function samePositions(a: readonly string[], b: readonly string[]): boolean {
  return a.length === b.length && a.every((p) => b.includes(p));
}
